const dev = false;
const localHost = "http://lingyin.qihe.local";
const proHost = "https://lingyin.zj-qq.cn";
const devHost = dev ? localHost : proHost;
export const HOST = process.env.NODE_ENV === "production" ? proHost : devHost;
export const TOKEN_EXPIRE = 59 * 60 * 1000; // token 有效期
export const DESENSITIZE_INFO = true; // 用户信息是否脱敏展示
export const APP_ID = "wxa8b6518eab6b88fb";
